<ng-container *ngIf="isSlipsDetailsOpen">
    <label>{{ messages.hide }}</label>
    <i class="theme-up"></i>
</ng-container>
<ng-container *ngIf="!isSlipsDetailsOpen">
    <label>{{ messages.show }}</label>
    <i class="theme-down"></i>
</ng-container>
